export const nswGrey = {
  '50': '#fafafa',
  '100': '#f5f5f5',
  '150': '#f0f0f0',
  '200': '#ebebeb',
  '250': '#e3e5e6',
  '300': '#dcdfe0',
  '350': '#d4d9db',
  '400': '#cdd3d6',
  '450': '#aab0b4',
  '500': '#888f92',
  '550': '#686f72',
  '600': '#495054',
  '650': '#3f4549',
  '700': '#353b3f',
  '750': '#2b3135',
  '800': '#22272b',
  '850': '#181c1f',
  '900': '#0e1113',
  '950': '#050709',
}
export const nswGreen = {
  '50': '#f5fff6',
  '100': '#ecfdee',
  '150': '#e4fce7',
  '200': '#dbfadf',
  '250': '#cff7d4',
  '300': '#c2f4c9',
  '350': '#b5f0be',
  '400': '#a8edb3',
  '450': '#8adc98',
  '500': '#6acc7d',
  '550': '#45bb62',
  '600': '#00aa45',
  '650': '#078e32',
  '700': '#077320',
  '750': '#03590f',
  '800': '#004000',
  '850': '#003000',
  '900': '#002000',
  '950': '#001100',
}
export const nswTeal = {
  '50': '#f2fbfa',
  '100': '#e7f7f5',
  '150': '#dcf2ef',
  '200': '#d1eeea',
  '250': '#c1eae7',
  '300': '#afe5e5',
  '350': '#9ee0e5',
  '400': '#8cdbe5',
  '450': '#75c4cf',
  '500': '#5eacb9',
  '550': '#4696a3',
  '600': '#2e808e',
  '650': '#256f7b',
  '700': '#1c5f69',
  '750': '#144e58',
  '800': '#0b3f47',
  '850': '#042f35',
  '900': '#011f24',
  '950': '#001114',
}
export const nswBlue = {
  '50': '#f0fbff',
  '100': '#e4f6ff',
  '150': '#d7f2fe',
  '200': '#cbedfd',
  '250': '#bceafe',
  '300': '#ade7ff',
  '350': '#9de3ff',
  '400': '#8ce0ff',
  '450': '#5ac9ff',
  '500': '#26aeff',
  '550': '#008fff',
  '600': '#146cfd',
  '650': '#0c5ad4',
  '700': '#0548ad',
  '750': '#023688',
  '800': '#002664',
  '850': '#001a4d',
  '900': '#001037',
  '950': '#000622',
}
export const nswPurple = {
  '50': '#f9f7ff',
  '100': '#f2f0ff',
  '150': '#ece8fe',
  '200': '#e6e1fd',
  '250': '#e0d9fe',
  '300': '#dad0fe',
  '350': '#d4c8ff',
  '400': '#cebfff',
  '450': '#baa6fc',
  '500': '#a68df9',
  '550': '#9372f5',
  '600': '#8055f1',
  '650': '#7243cf',
  '700': '#6432ae',
  '750': '#54218e',
  '800': '#441170',
  '850': '#330856',
  '900': '#23023e',
  '950': '#130027',
}
export const nswFuchsia = {
  '50': '#fff6fd',
  '100': '#ffeef9',
  '150': '#fee6f6',
  '200': '#fddef2',
  '250': '#fbd4ef',
  '300': '#f9c9eb',
  '350': '#f7bfe9',
  '400': '#f4b5e6',
  '450': '#ef96da',
  '500': '#e975cc',
  '550': '#e150be',
  '600': '#d912ae',
  '650': '#bb0c94',
  '700': '#9d067b',
  '750': '#810264',
  '800': '#65004d',
  '850': '#4d003a',
  '900': '#370028',
  '950': '#220017',
}
export const nswRed = {
  '50': '#fff8f9',
  '100': '#fff2f4',
  '150': '#ffecef',
  '200': '#ffe6ea',
  '250': '#ffdbe0',
  '300': '#ffcfd6',
  '350': '#ffc4cc',
  '400': '#ffb8c1',
  '450': '#f897a2',
  '500': '#ef7581',
  '550': '#e44f5f',
  '600': '#d7153a',
  '650': '#b90e32',
  '700': '#9b072a',
  '750': '#7e0322',
  '800': '#630019',
  '850': '#4c0010',
  '900': '#360008',
  '950': '#210003',
}
export const nswOrange = {
  '50': '#fffaf6',
  '100': '#fff6ee',
  '150': '#fef1e7',
  '200': '#fdeddf',
  '250': '#fee5ce',
  '300': '#ffddbd',
  '350': '#ffd6ab',
  '400': '#ffce99',
  '450': '#fdb678',
  '500': '#fb9d58',
  '550': '#f78139',
  '600': '#f3631b',
  '650': '#db5115',
  '700': '#c33f0e',
  '750': '#ab2e06',
  '800': '#941b00',
  '850': '#730f00',
  '900': '#530400',
  '950': '#350000',
}
export const nswYellow = {
  '50': '#fffcf0',
  '100': '#fffae5',
  '150': '#fff7da',
  '200': '#fff4cf',
  '250': '#fff1c2',
  '300': '#feeeb5',
  '350': '#feeaa8',
  '400': '#fde79a',
  '450': '#fbda80',
  '500': '#facd63',
  '550': '#fabe42',
  '600': '#faaf05',
  '650': '#d49403',
  '700': '#af7a01',
  '750': '#8b6000',
  '800': '#694800',
  '850': '#503500',
  '900': '#392400',
  '950': '#221300',
}
export const nswBrown = {
  '50': '#fbf8f4',
  '100': '#f6f1ea',
  '150': '#f2eae1',
  '200': '#ede3d7',
  '250': '#ecdece',
  '300': '#eadac6',
  '350': '#e9d5bd',
  '400': '#e8d0b5',
  '450': '#dbbf9f',
  '500': '#cfae89',
  '550': '#c29d73',
  '600': '#b68d5d',
  '650': '#9c764b',
  '700': '#82603a',
  '750': '#6a4b29',
  '800': '#523719',
  '850': '#3e280f',
  '900': '#2b1a07',
  '950': '#190d02',
}
export const nswAboriginalGrey = {
  '50': '#f9f8f7',
  '100': '#f2f1ef',
  '150': '#ebeae8',
  '200': '#e5e3e0',
  '250': '#dfdcd8',
  '300': '#d8d4d1',
  '350': '#d2cdc9',
  '400': '#ccc6c2',
  '450': '#ada8a5',
  '500': '#8e8b8a',
  '550': '#71706f',
  '600': '#555555',
  '650': '#494949',
  '700': '#3d3d3d',
  '750': '#323232',
  '800': '#272727',
  '850': '#1c1c1c',
  '900': '#111111',
  '950': '#070707',
}
export const nswAboriginalRed = {
  '50': '#fff5f5',
  '100': '#ffebeb',
  '150': '#fee2e2',
  '200': '#fdd9d9',
  '250': '#fdd0d0',
  '300': '#fcc7c6',
  '350': '#fcbdbd',
  '400': '#fbb4b3',
  '450': '#f79693',
  '500': '#f27771',
  '550': '#ea554c',
  '600': '#e1261c',
  '650': '#cd1f17',
  '700': '#ba1811',
  '750': '#a7110b',
  '800': '#950906',
  '850': '#740001',
  '900': '#540000',
  '950': '#360000',
}
export const nswAboriginalOrange = {
  '50': '#fff4ec',
  '100': '#fee9dd',
  '150': '#fcdfcd',
  '200': '#f9d4be',
  '250': '#f8caae',
  '300': '#f7bf9e',
  '350': '#f6b58e',
  '400': '#f4aa7d',
  '450': '#f39a66',
  '500': '#f2894f',
  '550': '#f07736',
  '600': '#ee6314',
  '650': '#d45310',
  '700': '#ba440a',
  '750': '#a13505',
  '800': '#882600',
  '850': '#691900',
  '900': '#4c0d00',
  '950': '#300300',
}
export const nswAboriginalBrown = {
  '50': '#fcf1e9',
  '100': '#f6e3d7',
  '150': '#efd5c4',
  '200': '#e9c8b2',
  '250': '#e4ba9f',
  '300': '#dead8c',
  '350': '#d99f78',
  '400': '#d39165',
  '450': '#c68158',
  '500': '#b9724b',
  '550': '#ab623e',
  '600': '#9e5332',
  '650': '#8b4627',
  '700': '#79391c',
  '750': '#672d10',
  '800': '#552105',
  '850': '#411602',
  '900': '#2d0c00',
  '950': '#1b0400',
}
export const nswAboriginalYellow = {
  '50': '#fffcee',
  '100': '#fff8e0',
  '150': '#fff5d3',
  '200': '#fff1c5',
  '250': '#ffeeb7',
  '300': '#ffeba9',
  '350': '#fee79b',
  '400': '#fee48c',
  '450': '#fed675',
  '500': '#fec85d',
  '550': '#feb944',
  '600': '#fea927',
  '650': '#df961c',
  '700': '#c18312',
  '750': '#a57007',
  '800': '#895e00',
  '850': '#694700',
  '900': '#4c3000',
  '950': '#2f1c00',
}
export const nswAboriginalGreen = {
  '50': '#f5f9f2',
  '100': '#ecf3e7',
  '150': '#e3ecdc',
  '200': '#dae6d1',
  '250': '#d1e0c6',
  '300': '#c7d9ba',
  '350': '#bed3af',
  '400': '#b5cda4',
  '450': '#a5c28e',
  '500': '#95b777',
  '550': '#86ac60',
  '600': '#78a146',
  '650': '#5f8f44',
  '700': '#497d40',
  '750': '#346a3b',
  '800': '#215834',
  '850': '#154225',
  '900': '#0a2e17',
  '950': '#021b0a',
}
export const nswAboriginalBlue = {
  '50': '#eef8fa',
  '100': '#dff1f4',
  '150': '#d0e9ee',
  '200': '#c1e2e8',
  '250': '#b2dbe2',
  '300': '#a3d4dc',
  '350': '#94ccd7',
  '400': '#84c5d1',
  '450': '#67aec0',
  '500': '#4a96b0',
  '550': '#2e7fa1',
  '600': '#0d6791',
  '650': '#095d84',
  '700': '#055377',
  '750': '#02496a',
  '800': '#00405e',
  '850': '#002f48',
  '900': '#002033',
  '950': '#00111f',
}
export const nswAboriginalPurple = {
  '50': '#faf1f8',
  '100': '#f2e5f0',
  '150': '#ebd8e8',
  '200': '#e4cce0',
  '250': '#ddbfd8',
  '300': '#d7b3d1',
  '350': '#d0a6c9',
  '400': '#c99ac2',
  '450': '#bd8bb6',
  '500': '#b17caa',
  '550': '#a66d9f',
  '600': '#9a5e93',
  '650': '#844f7e',
  '700': '#6f4169',
  '750': '#5b3355',
  '800': '#472642',
  '850': '#351a31',
  '900': '#241021',
  '950': '#150612',
}
export const success = {
  '50': '#eff9ed',
  '100': '#e0f3de',
  '150': '#d2eccf',
  '200': '#c4e5c0',
  '250': '#aad6a5',
  '300': '#8fc78a',
  '350': '#74b76f',
  '400': '#58a854',
  '450': '#49a146',
  '500': '#399936',
  '550': '#259224',
  '600': '#008a07',
  '650': '#007204',
  '700': '#005a02',
  '750': '#004401',
  '800': '#002f00',
  '850': '#002200',
  '900': '#001600',
  '950': '#000b00',
}
export const warning = {
  '50': '#fff3ed',
  '100': '#ffe8de',
  '150': '#ffddcf',
  '200': '#fdd2c0',
  '250': '#f6bda5',
  '300': '#eea88a',
  '350': '#e6936f',
  '400': '#dd7d53',
  '450': '#d87244',
  '500': '#d36734',
  '550': '#ce5c21',
  '600': '#c95000',
  '650': '#a83f03',
  '700': '#882f03',
  '750': '#692001',
  '800': '#4b1200',
  '850': '#390a00',
  '900': '#270400',
  '950': '#170100',
}
export const danger = {
  '50': '#fff0ef',
  '100': '#ffe2e1',
  '150': '#ffd4d4',
  '200': '#fdc6c6',
  '250': '#f4acad',
  '300': '#ea9294',
  '350': '#df787c',
  '400': '#d35d65',
  '450': '#cd4e59',
  '500': '#c63f4e',
  '550': '#bf2c42',
  '600': '#b81237',
  '650': '#990b2a',
  '700': '#7c061f',
  '750': '#5f0214',
  '800': '#44000a',
  '850': '#330005',
  '900': '#230002',
  '950': '#140001',
}
export const info = {
  '50': '#e9eef7',
  '100': '#d4ddeb',
  '150': '#c0cce0',
  '200': '#acbbd5',
  '250': '#96a9cc',
  '300': '#8098c2',
  '350': '#6b86b8',
  '400': '#5775ae',
  '450': '#4d6ca9',
  '500': '#4264a4',
  '550': '#385b9e',
  '600': '#2e5299',
  '650': '#23427f',
  '700': '#193366',
  '750': '#10254f',
  '800': '#071738',
  '850': '#040f2a',
  '900': '#02071c',
  '950': '#00030f',
}
export const white = '#ffffff'
export const black = '#000000'
